<template>
  <q-page padding>
    <div class="row col-12 text-brand-5" @click="voltar(ptId)">
      <q-icon
        style="margin-top: 3px"
        size="sm"
        name="arrow_back_ios"
        class="cursor"
      />
      <p class="text-h6 text-brand-5 text-weight-bold titulo-pagina">
        Anexos: #{{ ptId }}
      </p>
    </div>
    <div
      style="margin-left: 30px"
      class="text-brand-5 text-h6 text-weight-bold q-mt-md titulo-input"
    >
      Enviar Documento
    </div>

    <div
      class="row col-12 q-ml-xl text-brand-5 text-weight-bold q-gutter-x-sm container-input-file"
    >
      <div style="margin-top: 31px" class="container">
        <label class="btn info" for="arquivo"> Selecionar Arquivo</label>
        <div class="text-brand-5 text-weight-bold text q-ml-sm texto-arquivo">
          {{ file ? file.name : "Nenhum arquivo escolhido" }}
        </div>
        <input id="arquivo" type="file" @change="onFileSelected" />
        <span class="icon">
          <img src="../../../../assets/file_upload_black.svg" alt="" />
        </span>
      </div>
    </div>
    <div
      class="row col-12 q-mt-lg q-ml-xl q-gutter-sm text-brand-5 text-bold container-input-descricao"
    >
      <div class="col-md-4 col-sm-12 col-xs-12">
        <div class="q-ml-sm titulo-input-desc">Descrição</div>
        <q-input class="input-desc" dense outlined v-model="dados.descricao" />
      </div>
      <div>
        <p></p>
        <q-btn
          class="q-mt-sm btn-quasar"
          label="Enviar Documento"
          color="positive"
          no-caps
          dense
          icon="check_circle_outline"
          @click="handleFileUpload()"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <div class="row q-mb-lg justify-end">
        <div>
          <div>
            <q-btn
              class="q-mt-sm btn-quasar"
              label="Imprimir"
              color="primary"
              no-caps
              dense
              outline
              icon="print"
              @click="imprimir()"
            />
          </div>
        </div>
      </div>
      <q-table
        table-header-class="bg-accent text-weight-bold"
        :grid="$q.screen.lt.sm"
        flat
        dense
        :columns="columns"
        class="tabela-tamanho-fixo"
        :loading="loading"
        :rows="listaAnexos"
        hide-bottom
        :rows-per-page-options="[0]"
      >
        <template v-slot:item="props">
          <div class="q-pa-xs col-xs-12 col-sm-6 col-md-4">
            <div class="row col-12 justify-between card">
              <div class="col-3">
                <a @click.prevent="abrirArquivo(props.row)">
                  <q-btn
                    label="Arquivo"
                    icon="open_in_new"
                    no-caps
                    style="
                      border-radius: 0px;
                      background: #393939;
                      color: #fff;
                      height: 100%;
                    "
                    size="18px"
                    stack
                  />
                </a>
              </div>
              <div class="col q-ml-md q-mt-xs">
                <div class="row col-12 text-grid text-brand-5">
                  <span><strong>Nome: </strong>{{ props.row.nome }}</span>
                </div>
                <div class="row col-12 text-grid text-brand-5">
                  <span
                    ><strong>Descrição: </strong
                    >{{
                      props.row.descricao ? props.row.descricao : "Sem Obs."
                    }}</span
                  >
                </div>
                <div class="row col-12 text-grid text-brand-5">
                  <span
                    ><strong>Upload Por: </strong
                    >{{ props.row.usuarioNome }}</span
                  >
                </div>
                <div class="row col-12 text-grid text-brand-5">
                  <span
                    ><q-icon name="event" /><strong>Data de Envio: </strong
                    >{{
                      props.row.dataHoraEnvio
                        .split(" ")[0]
                        .split("-")
                        .reverse()
                        .join("/")
                    }}</span
                  >
                </div>
              </div>
              <div class="row col-2">
                <q-btn
                  :disable="!usuarioPodeEditar"
                  icon="remove_circle_outline"
                  no-caps
                  flat
                  color="red"
                  size="lg"
                  @click="
                    (confirm = confirm = true), recebeAnexoId(props.row.anexoId)
                  "
                />
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-arquivo="props">
          <q-td :props="props">
            <a @click.prevent="abrirArquivo(props.row)">
              <q-btn color="brand-5" flat icon="open_in_new"
            /></a>
          </q-td>
        </template>
        <template v-slot:body-cell-nome="props">
          <q-td class="text-brand-4 text-weigth-bold" :props="props"
            >{{ props.row.nome }}
          </q-td>
        </template>
        <template v-slot:body-cell-uploadPor="props">
          <q-td class="text-brand-4 text-weigth-bold" :props="props"
            >{{ props.row.usuarioNome }}
          </q-td>
        </template>
        <template v-slot:body-cell-descricao="props">
          <q-td class="text-brand-4 text-weigth-bold" :props="props"
            >{{ props.row.descricao ? props.row.descricao : "Sem Obs." }}
          </q-td>
        </template>
        <template v-slot:body-cell-status="props">
          <q-td style="padding: 0; margin: 0" key="status" :props="props">
            <div
              v-if="props.row.statusPt == 'aberto'"
              style="width: fit-content; background: #fefed1; padding: 2px 5px"
              class="row align items-center"
            >
              <span
                v-if="props.row.statusPt == 'finalizado'"
                class="elipse q-mr-sm bg-positive"
              ></span>
              <span
                v-if="props.row.statusPt == 'iniciado'"
                class="elipse q-mr-sm"
                style="background: #6391f4"
              ></span>
              <span
                v-if="props.row.statusPt == 'aguardando_assinaturas'"
                class="elipse q-mr-sm"
                style="background: #dba700"
              ></span>
              <span
                v-if="props.row.statusPt == 'aberto'"
                class="elipse q-mr-sm"
                style="background: #b4a913"
              ></span>
              <span
                v-if="props.row.statusPt == 'encerrado'"
                class="elipse q-mr-sm"
                style="background: #2d3e6e"
              ></span>
              <span
                v-if="props.row.statusPt == 'cancelado'"
                class="elipse q-mr-sm"
                style="background: #707070"
              ></span>
              <div
                v-if="props.row.statusPt == 'finalizado'"
                style="width: fit-content; background: #e8ffec"
                class="text-brand-5 text-bold"
              >
                {{ "Finalizado" }}
              </div>
              <div
                v-if="props.row.statusPt == 'iniciado'"
                style="width: fit-content; background: #ecf1fe"
                class="text-brand-5 text-bold"
              >
                {{ "Iniciado" }}
              </div>
              <div
                v-if="props.row.statusPt == 'aguardando_assinaturas'"
                style="width: fit-content; background: #fff6e3; color: #683f09"
                class="text-bold"
              >
                {{ "Em Ass." }}
              </div>
              <div
                v-if="props.row.statusPt == 'aberto'"
                style="width: fit-content; background: #fefed1; color: #b4a913"
                class="text-bold"
              >
                {{ "Em Aberto" }}
              </div>
              <div
                v-if="props.row.statusPt == 'encerrado'"
                style="width: fit-content; background: #f8f8f8; color: #192957"
                class="text-bold"
              >
                {{ "Encerrado" }}
              </div>
              <div
                v-if="props.row.statusPt == 'cancelado'"
                style="width: fit-content; background: #efecec"
                class="text-brand-5 text-bold"
              >
                {{ "Cancelado" }}
              </div>
            </div>
            <div
              v-if="props.row.statusPt == 'finalizado'"
              style="width: fit-content; background: #e8ffec; padding: 2px 5px"
              class="row align items-center"
            >
              <span
                v-if="props.row.statusPt == 'finalizado'"
                class="elipse q-mr-sm bg-positive"
              ></span>
              <span
                v-if="props.row.statusPt == 'iniciado'"
                class="elipse q-mr-sm"
                style="background: #6391f4"
              ></span>
              <span
                v-if="props.row.statusPt == 'aguardando_assinaturas'"
                class="elipse q-mr-sm"
                style="background: #dba700"
              ></span>
              <span
                v-if="props.row.statusPt == 'aberto'"
                class="elipse q-mr-sm"
                style="background: #b4a913"
              ></span>
              <span
                v-if="props.row.statusPt == 'encerrado'"
                class="elipse q-mr-sm"
                style="background: #2d3e6e"
              ></span>
              <span
                v-if="props.row.statusPt == 'cancelado'"
                class="elipse q-mr-sm"
                style="background: #707070"
              ></span>
              <div
                v-if="props.row.statusPt == 'finalizado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Finalizado" }}
              </div>
              <div
                v-if="props.row.statusPt == 'iniciado'"
                style="width: fit-content; background: #ecf1fe"
                class="text-brand-5 text-bold"
              >
                {{ "Iniciado" }}
              </div>
              <div
                v-if="props.row.statusPt == 'aguardando_assinaturas'"
                style="width: fit-content; color: #683f09"
                class="text-bold"
              >
                {{ "Em Ass." }}
              </div>
              <div
                v-if="props.row.statusPt == 'aberto'"
                style="width: fit-content; color: #b4a913"
                class="text-bold"
              >
                {{ "Em Aberto" }}
              </div>
              <div
                v-if="props.row.statusPt == 'encerrado'"
                style="width: fit-content; color: #192957"
                class="text-bold"
              >
                {{ "Encerrado" }}
              </div>
              <div
                v-if="props.row.statusPt == 'cancelado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Cancelado" }}
              </div>
            </div>
            <div
              v-if="props.row.statusPt == 'iniciado'"
              style="width: fit-content; background: #ecf1fe; padding: 2px 5px"
              class="row align items-center"
            >
              <span
                v-if="props.row.statusPt == 'finalizado'"
                class="elipse q-mr-sm bg-positive"
              ></span>
              <span
                v-if="props.row.statusPt == 'iniciado'"
                class="elipse q-mr-sm"
                style="background: #6391f4"
              ></span>
              <span
                v-if="props.row.statusPt == 'aguardando_assinaturas'"
                class="elipse q-mr-sm"
                style="background: #dba700"
              ></span>
              <span
                v-if="props.row.statusPt == 'aberto'"
                class="elipse q-mr-sm"
                style="background: #b4a913"
              ></span>
              <span
                v-if="props.row.statusPt == 'encerrado'"
                class="elipse q-mr-sm"
                style="background: #2d3e6e"
              ></span>
              <span
                v-if="props.row.statusPt == 'cancelado'"
                class="elipse q-mr-sm"
                style="background: #707070"
              ></span>
              <div
                v-if="props.row.statusPt == 'finalizado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Finalizado" }}
              </div>
              <div
                v-if="props.row.statusPt == 'iniciado'"
                style="width: fit-content; background: #ecf1fe"
                class="text-brand-5 text-bold"
              >
                {{ "Iniciado" }}
              </div>
              <div
                v-if="props.row.statusPt == 'aguardando_assinaturas'"
                style="width: fit-content; color: #683f09"
                class="text-bold"
              >
                {{ "Em Ass." }}
              </div>
              <div
                v-if="props.row.statusPt == 'aberto'"
                style="width: fit-content; color: #b4a913"
                class="text-bold"
              >
                {{ "Em Aberto" }}
              </div>
              <div
                v-if="props.row.statusPt == 'encerrado'"
                style="width: fit-content; color: #192957"
                class="text-bold"
              >
                {{ "Encerrado" }}
              </div>
              <div
                v-if="props.row.statusPt == 'cancelado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Cancelado" }}
              </div>
            </div>
            <div
              v-if="props.row.statusPt == 'encerrado'"
              style="width: fit-content; background: #f8f8f8; padding: 2px 5px"
              class="row align items-center"
            >
              <span
                v-if="props.row.statusPt == 'finalizado'"
                class="elipse q-mr-sm bg-positive"
              ></span>
              <span
                v-if="props.row.statusPt == 'iniciado'"
                class="elipse q-mr-sm"
                style="background: #6391f4"
              ></span>
              <span
                v-if="props.row.statusPt == 'aguardando_assinaturas'"
                class="elipse q-mr-sm"
                style="background: #dba700"
              ></span>
              <span
                v-if="props.row.statusPt == 'aberto'"
                class="elipse q-mr-sm"
                style="background: #b4a913"
              ></span>
              <span
                v-if="props.row.statusPt == 'encerrado'"
                class="elipse q-mr-sm"
                style="background: #2d3e6e"
              ></span>
              <span
                v-if="props.row.statusPt == 'cancelado'"
                class="elipse q-mr-sm"
                style="background: #707070"
              ></span>
              <div
                v-if="props.row.statusPt == 'finalizado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Finalizado" }}
              </div>
              <div
                v-if="props.row.statusPt == 'iniciado'"
                style="width: fit-content; background: #ecf1fe"
                class="text-brand-5 text-bold"
              >
                {{ "Iniciado" }}
              </div>
              <div
                v-if="props.row.statusPt == 'aguardando_assinaturas'"
                style="width: fit-content; color: #683f09"
                class="text-bold"
              >
                {{ "Em Ass." }}
              </div>
              <div
                v-if="props.row.statusPt == 'aberto'"
                style="width: fit-content; color: #b4a913"
                class="text-bold"
              >
                {{ "Em Aberto" }}
              </div>
              <div
                v-if="props.row.statusPt == 'encerrado'"
                style="width: fit-content; color: #192957"
                class="text-bold"
              >
                {{ "Encerrado" }}
              </div>
              <div
                v-if="props.row.statusPt == 'cancelado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Cancelado" }}
              </div>
            </div>
            <div
              v-if="props.row.statusPt == 'cancelado'"
              style="width: fit-content; background: #efecec; padding: 2px 5px"
              class="row align items-center"
            >
              <span
                v-if="props.row.statusPt == 'finalizado'"
                class="elipse q-mr-sm bg-positive"
              ></span>
              <span
                v-if="props.row.statusPt == 'iniciado'"
                class="elipse q-mr-sm"
                style="background: #6391f4"
              ></span>
              <span
                v-if="props.row.statusPt == 'aguardando_assinaturas'"
                class="elipse q-mr-sm"
                style="background: #dba700"
              ></span>
              <span
                v-if="props.row.statusPt == 'aberto'"
                class="elipse q-mr-sm"
                style="background: #b4a913"
              ></span>
              <span
                v-if="props.row.statusPt == 'encerrado'"
                class="elipse q-mr-sm"
                style="background: #2d3e6e"
              ></span>
              <span
                v-if="props.row.statusPt == 'cancelado'"
                class="elipse q-mr-sm"
                style="background: #707070"
              ></span>
              <div
                v-if="props.row.statusPt == 'finalizado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Finalizado" }}
              </div>
              <div
                v-if="props.row.statusPt == 'iniciado'"
                style="width: fit-content; background: #ecf1fe"
                class="text-brand-5 text-bold"
              >
                {{ "Iniciado" }}
              </div>
              <div
                v-if="props.row.statusPt == 'aguardando_assinaturas'"
                style="width: fit-content; color: #683f09"
                class="text-bold"
              >
                {{ "Em Ass." }}
              </div>
              <div
                v-if="props.row.statusPt == 'aberto'"
                style="width: fit-content; color: #b4a913"
                class="text-bold"
              >
                {{ "Em Aberto" }}
              </div>
              <div
                v-if="props.row.statusPt == 'encerrado'"
                style="width: fit-content; color: #192957"
                class="text-bold"
              >
                {{ "Encerrado" }}
              </div>
              <div
                v-if="props.row.statusPt == 'cancelado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Cancelado" }}
              </div>
            </div>
            <div
              v-if="props.row.statusPt == 'aguardando_assinaturas'"
              style="width: fit-content; background: #fff6e3; padding: 2px 5px"
              class="row align items-center"
            >
              <span
                v-if="props.row.statusPt == 'finalizado'"
                class="elipse q-mr-sm bg-positive"
              ></span>
              <span
                v-if="props.row.statusPt == 'iniciado'"
                class="elipse q-mr-sm"
                style="background: #6391f4"
              ></span>
              <span
                v-if="props.row.statusPt == 'aguardando_assinaturas'"
                class="elipse q-mr-sm"
                style="background: #dba700"
              ></span>
              <span
                v-if="props.row.statusPt == 'aberto'"
                class="elipse q-mr-sm"
                style="background: #b4a913"
              ></span>
              <span
                v-if="props.row.statusPt == 'encerrado'"
                class="elipse q-mr-sm"
                style="background: #2d3e6e"
              ></span>
              <span
                v-if="props.row.statusPt == 'cancelado'"
                class="elipse q-mr-sm"
                style="background: #707070"
              ></span>
              <div
                v-if="props.row.statusPt == 'finalizado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Finalizado" }}
              </div>
              <div
                v-if="props.row.statusPt == 'iniciado'"
                style="width: fit-content; background: #ecf1fe"
                class="text-brand-5 text-bold"
              >
                {{ "Iniciado" }}
              </div>
              <div
                v-if="props.row.statusPt == 'aguardando_assinaturas'"
                style="width: fit-content; color: #683f09"
                class="text-bold"
              >
                {{ "Em Ass." }}
              </div>
              <div
                v-if="props.row.statusPt == 'aberto'"
                style="width: fit-content; color: #b4a913"
                class="text-bold"
              >
                {{ "Em Aberto" }}
              </div>
              <div
                v-if="props.row.statusPt == 'encerrado'"
                style="width: fit-content; color: #192957"
                class="text-bold"
              >
                {{ "Encerrado" }}
              </div>
              <div
                v-if="props.row.statusPt == 'cancelado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Cancelado" }}
              </div>
            </div>
          </q-td>
        </template>
        <template v-slot:body-cell-datahoraenvio="props">
          <q-td class="text-brand-4 text-weigth-bold" :props="props">
            <div>
              {{
                props.row.dataHoraEnvio
                  .split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}
              <p style="margin: 0 0 0 9px">
                {{ props.row.dataHoraEnvio.split(" ")[1] }}
              </p>
            </div>
          </q-td>
        </template>
        <template v-slot:body-cell-remover="props">
          <q-td :props="props">
            <q-btn
              :disable="!usuarioPodeEditar"
              color="white"
              text-color="red"
              flat
              label="Remover"
              no-caps
              icon="remove_circle_outline"
              @click="
                (confirm = confirm = true), recebeAnexoId(props.row.anexoId)
              "
            />
          </q-td>
        </template>
      </q-table>
    </div>
    <q-dialog v-model="confirm" persistent>
      <q-card class="q-pa-sm text-brand-5 text-weight-bolder">
        <q-card-section class="row items-center">
          <span class="q-ml-sm"
            >Você tem certeza que deseja remover esse anexo?</span
          >
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            icon="cancel"
            no-caps
            dense
            outline
            label="Não"
            color="negative"
            v-close-popup
          />
          <q-btn
            no-caps
            dense
            outline
            label="Sim"
            color="positive"
            v-close-popup
            icon="check_circle_outline"
            @click="removerAnexo()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";
import { onMounted, ref, computed } from "vue";

export default {
  setup() {
    const columns = [
      {
        name: "arquivo",
        label: "Arquivo",
        align: "left",
        field: "",
      },
      {
        name: "nome",
        label: "Nome",
        align: "left",
        field: "nome",
      },
      {
        name: "uploadPor",
        label: "Upload Por",
        align: "left",
        field: "usuarioNome",
      },
      {
        name: "descricao",
        label: "Descrição",
        align: "left",
        field: "descricao",
      },
      {
        name: "status",
        label: "Status do Anexo",
        align: "left",
        field: "statusPt",
      },
      {
        name: "datahoraenvio",
        label: "Data de Envio",
        align: "left",
        field: "dataHoraEnvio",
      },
      {
        name: "remover",
        label: "Remover",
        align: "center",
      },
    ];
    const route = useRoute();
    const store = useStore();
    const quasar = useQuasar();
    const router = useRouter();
    const ptId = route.params.ptId;
    const file = ref(null);
    const pt = ref();
    const listaAnexos = ref([]);
    let loading = ref(false);
    let dados = ref({
      descricao: "",
    });
    let confirm = ref(false);
    const anexoId = ref("");

    let onFileSelected = async (e) => {
      if (e.target.files[0].length === 0) {
        return;
      }
      file.value = e.target.files[0];
    };

    const buscarDetalheAnexos = async () => {
      loading.value = true;
      store.dispatch("pdt/hiddenHeader", true);
      let resposta = await store.dispatch("pdt/buscarDetalhePt", { ptId });
      pt.value = resposta.data.resultado.dados;
      if (resposta.data.resultado.dados.anexos) {
        listaAnexos.value = resposta.data.resultado.dados.anexos;
      } else {
        listaAnexos.value = [];
      }
      loading.value = false;
    };

    const abrirArquivo = () => {
      router.push({ name: "pdt-pt-imprimir-anexos", params: { ptId } });
    };

    const handleFileUpload = async () => {
      if (!file.value) {
        quasar.notify({
          message: "Nenhum arquivo selecionado.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      const resposta = await store.dispatch("pdt/getUploadAnexo", {
        ptId,
        nomeArquivo: file.value.name,
      });

      let formAttributes = resposta.data.resultado.dados.formAttributes;
      let formInputs = resposta.data.resultado.dados.formInputs;
      const formData = new FormData();

      for (let input in formInputs) {
        formData.append(input, formInputs[input]);
      }

      formData.append("file", file.value);
      var request = new XMLHttpRequest();
      request.open(formAttributes.method, formAttributes.action);
      await request.send(formData);

      try {
        if (pt.value.status != "encerrado") {
          await store.dispatch("pdt/enviarAnexoGeral", {
            ptId,
            url: `${formAttributes.action}/${formInputs.key}`,
            descricao: dados.value.descricao,
          });

          quasar.notify({
            message: "Anexo Geral enviado com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          dados.value.descricao = "";
          buscarDetalheAnexos();

          file.value = null;
        } else if (pt.value.status === "encerrado") {
          await store.dispatch("pdt/enviarAnexoEncerramento", {
            ptId,
            url: `${formAttributes.action}/${formInputs.key}`,
            descricao: dados.value.descricao,
          });

          quasar.notify({
            message: "Anexo de Encerramento enviado com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          dados.value.descricao = "";
          buscarDetalheAnexos();
          file.value = null;
        }
      } catch (error) {
        quasar.notify({
          message: "Erro a o enviar anexo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        console.log(error);

        file.value = null;
      }
    };

    const usuarioPodeEditar = computed(() => {
      if (!pt.value) {
        return false;
      }

      return (
        store.getters["autenticacao/usuarioLogado"].id ===
        pt.value.emissorMatricula
      );
    });

    const removerAnexo = async () => {
      try {
        await store.dispatch("pdt/removerAnexo", {
          ptId: ptId,
          anexoId: anexoId.value,
        });
        quasar.notify({
          message: "Anexo removido",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        anexoId.value = "";
        buscarDetalheAnexos();
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao remover anexo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const voltar = async (ptId) => {
      router.push({ name: "pdt-pt-detalhe", params: { ptId } });
    };

    const imprimir = () => {
      router.push({ name: "pdt-pt-imprimir-anexos", params: { ptId } });
    };

    const recebeAnexoId = async (id) => {
      anexoId.value = id;
    };
    onMounted(buscarDetalheAnexos);

    return {
      columns,
      handleFileUpload,
      buscarDetalheAnexos,
      onFileSelected,
      file,
      listaAnexos,
      ptId,
      voltar,
      loading,
      removerAnexo,
      dados,
      usuarioPodeEditar,
      imprimir,
      confirm,
      recebeAnexoId,
      anexoId,
      abrirArquivo,
    };
  },
};
</script>

<style scoped>
input[type="file"] {
  display: none;
}
.btn {
  border: 2px solid black;
  background-color: white;
  color: black;
  border-radius: 5px;
  margin: 5px 5px 0 0;
  padding: 6px 20px;
  padding-left: 40px;
  cursor: pointer;
  border-color: #2196f3;
  color: #58afc1;
}
.info {
  border-color: #58afc1;
}
.text {
  display: inline;
}
.container {
  position: relative;
}
.icon {
  position: absolute;
  top: -2px;
  left: 9px;
}
.cursor {
  cursor: pointer;
}
a {
  text-decoration: none;
}
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
@media (max-width: 600px) {
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid {
    font-size: 10px;
  }
  .titulo-pagina {
    font-size: 14px;
  }
  .cursor {
    font-size: 14px !important;
    margin-top: 9px !important;
  }
  .titulo-input {
    display: none;
  }
  .container-input-file {
    margin: 0px;
  }
  .titulo-input-desc {
    margin: 0px;
    font-size: 12px;
  }
  .input-desc {
    font-size: 10px;
  }
  .container-input-descricao {
    margin: 15px 7px 0px 0px;
  }
  .texto-arquivo {
    font-size: 12px;
  }
  .btn {
    border: 2px solid black;
    background-color: white;
    color: black;
    border-radius: 5px;
    margin: 5px 5px 0 0;
    padding: 6px 6px;
    padding-left: 40px;
    cursor: pointer;
    border-color: #2196f3;
    color: #58afc1;
  }
  .info {
    border-color: #58afc1;
    font-size: 10px;
  }
  .btn-quasar {
    font-size: 12px;
  }
}
</style>
